import {combineReducers} from 'redux';

import consultationReducer from './consultation/reducer';

export default combineReducers({
    consultation: consultationReducer,
});
